/**
 * Centralized visibility lists for focus elements (menu, top bar).
 */
import Focus from '@shared/types/enums/focus';

// ------------------------------------------------------------
// Focus blacklists
// ------------------------------------------------------------

/** Focus keys that do not interact with the dial. */
export const DIAL_FOCUS_BLACKLIST = [
  Focus.ADS,
  Focus.MODAL_BUTTONS,
  Focus.SPLASH,
] as const;

/** Focus keys that do not interact with the main content. */
export const MAIN_FOCUS_BLACKLIST = [
  -1,
  Focus.MENU,
  Focus.SEARCH,
  Focus.SPLASH,
] as const;

/** Focus keys that do not interact with the mosaic content. */
export const MOSAIC_FOCUS_BLACKLIST = [
  Focus.MENU,
  Focus.LOGIN,
  Focus.MODAL_BUTTONS,
  Focus.FLOATING_MENU,
] as const;

/** Focus keys that do not interact with the menu (collapse/expand). */
export const MENU_FOCUS_BLACKLIST = [Focus.ADS, Focus.MODAL_BUTTONS] as const;

/** Focus keys that interact with the menu (collapse/expand). */
export const MENU_FOCUS_WHITELIST = [
  Focus.LOGIN,
  Focus.MENU,
  Focus.SEARCH,
  Focus.SPLASH,
] as const;

/** Focus keys that prevent the slider list from auto advancing. */
export const SLIDER_FOCUS_BLACKLIST = [Focus.ADS, Focus.SPLASH] as const;
